import React, { useState } from "react";
import axios from "axios";
import { Helmet } from "react-helmet";
import { FaEnvelope, FaLocationDot, FaPhone, FaWhatsapp } from "react-icons/fa6";
import SupportMapGraphic from "../images/graphics/support-map.svg";
import PageHero from "../components/pageHero";
import { buildApiUrl } from "../utils/api";
import { contactMethodOptions } from "../utils/marketplaceOptions";

const initialForm = {
  name: "",
  email: "",
  contactNumber: "",
  firmName: "",
  subject: "I would like to speak with the CS team",
  serviceNeed: "General consultation",
  preferredContactMethod: "Email",
  message: ""
};

function ContactMarketplace() {
  const [formData, setFormData] = useState(initialForm);
  const [status, setStatus] = useState(null);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((previous) => ({ ...previous, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatus({ text: "Sending your message...", type: "success" });

    try {
      await axios.post(buildApiUrl("/api/enquiries"), formData);
      setFormData(initialForm);
      setStatus({ text: "Message submitted. Your CS team can follow up through your preferred channel.", type: "success" });
    } catch (error) {
      console.error("Error sending contact form:", error);
      setStatus({ text: "We could not submit your message right now. Please try again.", type: "error" });
    }
  };

  return (
    <>
      <Helmet>
        <title>Contact the CS Team | 3PL Search</title>
      </Helmet>

      <div className="contact-page">
        <PageHero
          eyebrow="Contact and consultation"
          title="Speak with the team that helps buyers move from enquiry to quote."
          description="Reach out for shortlist guidance, quote coordination, provider onboarding, or questions about the warehouse directory."
          image={SupportMapGraphic}
          imageAlt="Support coverage infographic"
          imageLight
          compact
        >
          <div className="surface-card contact-card">
            <div><FaPhone /><span>Phone: +1 (555) 010-3000</span></div>
            <div><FaWhatsapp /><span>WhatsApp: +1 (555) 010-3000</span></div>
            <div><FaEnvelope /><span>Email: cs@3plsearch.com</span></div>
            <div><FaLocationDot /><span>Serving buyers and providers across global logistics markets.</span></div>
          </div>
        </PageHero>

        <section className="content-section">
          <div className="container">
            <div className="row g-5">
              <div className="col-lg-8">
                <form className="lead-form-card" onSubmit={handleSubmit}>
                  <div className="row g-3">
                    <div className="col-md-6"><label>Full name</label><input name="name" value={formData.name} onChange={handleChange} required /></div>
                    <div className="col-md-6"><label>Company</label><input name="firmName" value={formData.firmName} onChange={handleChange} required /></div>
                    <div className="col-md-6"><label>Email</label><input type="email" name="email" value={formData.email} onChange={handleChange} required /></div>
                    <div className="col-md-6"><label>Phone</label><input name="contactNumber" value={formData.contactNumber} onChange={handleChange} required /></div>
                    <div className="col-md-6"><label>Preferred contact</label><select name="preferredContactMethod" value={formData.preferredContactMethod} onChange={handleChange}>{contactMethodOptions.map((option) => <option key={option} value={option}>{option}</option>)}</select></div>
                    <div className="col-md-6"><label>Subject</label><input name="subject" value={formData.subject} onChange={handleChange} required /></div>
                    <div className="col-12"><label>How can we help?</label><textarea rows="5" name="message" value={formData.message} onChange={handleChange} placeholder="Share your requirement, current challenge, or the type of warehouse/provider support you need." required /></div>
                  </div>
                  <div className="lead-form-actions">
                    <button className="site-primary-cta" type="submit">Send message</button>
                  </div>
                  {status ? <p className={`form-status ${status.type}`}>{status.text}</p> : null}
                </form>
              </div>

              <div className="col-lg-4">
                <div className="surface-card h-100">
                  <h3>Best for</h3>
                  <div className="info-panel">
                    <div><span>Buyer discovery support</span></div>
                    <div><span>Quote coordination and follow-up</span></div>
                    <div><span>Provider onboarding questions</span></div>
                    <div><span>Directory feedback and partnership enquiries</span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default ContactMarketplace;
